<template>
  <router-link
    v-if="trainNumber"
    :to="{ name: 'train', params: { trainNumber: trainNumber }}"
    custom
    v-slot="{ href, navigate }"
  >
    <a :href="href" @click.stop="navigate">{{ category }} {{ trainNumber }}</a>
  </router-link>
</template>

<script>
export default {
  name: 'TrainLink',
  props: ['category', 'trainNumber'],
};
</script>

<style scoped>
/* Sit above v-expansion-panel-title__overlay so the link is clickable
   inside a panel title (the overlay covers the title and would otherwise
   swallow the click, toggling the panel instead of following the link). */
a {
  position: relative;
  z-index: 1;
  /* Vuetify 3 no longer colors anchors by default (v2 did). */
  color: rgb(var(--v-theme-primary));
}
</style>
